export const HUE_STRUCTURES = {
  none: [],
  polar: [180],
  split: [150, 210],
  trine: [120, 240],
  square: [90, 180, 270],
}
export const CHANNEL_SPECIFIC_LUM = {
  R: 0.3,
  G: 0.5,
  B: 0.2,
}
/*
const I'M_WONDERING_IF_THIS_IS_NOT_VERY_ACCURATE = {
  R: 0.2126,
  G: 0.7152,
  B: 0.0722,
}
*/
